export default "__VITE_ASSET__6e5da3d0__"